import { ReactElement, useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {
    Button,
    DropdownWrapper,
    FlexWrapper,
    Input,
    PageWrapper,
    SectionTitle,
    TableHeader,
    TableWrapper
} from '../../../components'
import strings from '../../../locale/en'
import { getLearnSession, sessionNameApi } from '../../../redux/learnSession/api'
import { RootState } from '../../../redux/store'
import { TableRow } from '../User/subcomponents'
import { tableHeader } from './const'
import { BootstrapModal } from './subcomponent'

const LearnSession = (): ReactElement => {
    const {
        sessionPayload,
        sessionList,
    } = useSelector(
        (state: RootState) => ({
            sessionPayload: state.learnSession.sessionPayload,
            sessionList: state.learnSession.getAllSession,
        })
    )
    const {
        menu: {
            learnSession: {
                title,
                add,
                sessionNameLabel,
                placeholder: {
                    sessionName
                }
            }
        }
    } = strings

    const [showModal, setShowModal] = useState('')
    const [values, setValues] = useState(sessionPayload)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getLearnSession())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <PageWrapper>
            <FlexWrapper justifyContent='space-between' hasBorder>
                <SectionTitle title={title} />
                <Button
                    onClick={() => {
                        setShowModal('sfb')
                    }}
                >{add}</Button>
            </FlexWrapper>
            <>
                <TableWrapper>
                    <Table size='sm' responsive="sm">
                        <TableHeader>
                            <TableRow>
                                {tableHeader?.map((header, index) => (
                                    <th key={`session-list-header-${index}`}>{header}</th>
                                ))}
                            </TableRow>
                        </TableHeader>
                        <tbody>

                            {sessionList.map((data, index) => (
                                <TableRow key={index}>
                                    <td>  {index + 1}</td>
                                    <td>  {data?.name}</td>
                                    <td> {data.courseSessionDetailDao.map((list, index1) => {
                                        return (
                                            <div key={index1}>
                                                {list?.course}
                                            </div>
                                        )
                                    })}</td>
                                     <td> {data.courseSessionDetailDao.map((list, index1) => {
                                        return (
                                            <div key={index1}>
                                                {list?.subject}
                                            </div>
                                        )
                                    })}</td>
                                    <td> {data.courseSessionDetailDao.map((list, index1) => {
                                        return (
                                            <div key={index1}>
                                                {list?.chapter}

                                            </div>
                                        )
                                    })}</td>
                                    <td> {data.courseSessionDetailDao.map((list, index1) => {
                                        return (
                                            <div key={index1}>
                                                {list?.topic}

                                            </div>
                                        )
                                    })}</td>
                                </TableRow>
                            ))}

                        </tbody>
                    </Table>
                </TableWrapper>
            </>
            {showModal && (
                <BootstrapModal
                    handleCancel={() => setShowModal('')}
                    handleSubmit={() => {
                        dispatch(sessionNameApi({
                            name: values?.name
                        }))
                    }}
                    isLargeModal={true}
                >
                    <FlexWrapper justifyContent="center">
                        <DropdownWrapper width='50%'>
                            <Input
                                value={values?.name}
                                label={sessionNameLabel}
                                isRequired
                                placeholder={sessionName}
                                onChange={(value: string) => {
                                    setValues({
                                        ...values,
                                        name: value
                                    })
                                }}
                            />
                        </DropdownWrapper>
                    </FlexWrapper>
                </BootstrapModal>
            )}
        </PageWrapper>
    )
}

export default LearnSession